import Seo from "@/components/Seo";
import Marquee from "@/components/Marquee";
import { NewsletterSection } from "@/components/NewsletterForm";
import { PageIntro, FadeUp } from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";
import { Phone, Mail } from "lucide-react";

const Contact = () => {
    const { t } = useContent();
    return (
        <>
            <Seo
                title="Contact"
                description="Contact Panther City Clubhouse — (682) 334-2223 or panthercityclubhouse@gmail.com."
            />
            <PageIntro kicker="talk to a human" title="CONTACT US" intro={t("contact.intro", "")} />
            <section className="px-5 pb-16 sm:px-10">
                <div className="mx-auto grid max-w-4xl gap-10 sm:grid-cols-2">
                    <FadeUp>
                        <a
                            data-testid="contact-phone-card"
                            href="tel:+16823342223"
                            className="block border-2 border-ink bg-orange p-8 text-cream hard-shadow-lg -rotate-1 transition-transform duration-200 hover:-translate-y-1 hover:rotate-0"
                        >
                            <Phone className="h-10 w-10 text-mustard" />
                            <h2 className="mt-4 font-display text-2xl tracking-wide">CALL OR TEXT</h2>
                            <p className="mt-2 font-display text-3xl tracking-wide sm:text-4xl">{t("contact.phone", "(682) 334-2223")}</p>
                            <p className="mt-3 text-sm text-cream/85">If we don't pick up, we're probably holding a paint roller. Leave a message.</p>
                        </a>
                    </FadeUp>
                    <FadeUp delay={0.12}>
                        <a
                            data-testid="contact-email-card"
                            href="mailto:panthercityclubhouse@gmail.com"
                            className="block border-2 border-ink bg-forest p-8 text-cream hard-shadow-lg rotate-1 transition-transform duration-200 hover:-translate-y-1 hover:rotate-0"
                        >
                            <Mail className="h-10 w-10 text-mustard" />
                            <h2 className="mt-4 font-display text-2xl tracking-wide">EMAIL</h2>
                            <p className="mt-2 break-all font-display text-xl tracking-wide sm:text-2xl">
                                {t("contact.email", "panthercityclubhouse@gmail.com")}
                            </p>
                            <p className="mt-3 text-sm text-cream/85">Ideas, questions, rental inquiries, anonymous compliments — all welcome.</p>
                        </a>
                    </FadeUp>
                </div>
                <FadeUp className="mx-auto mt-12 max-w-4xl text-center">
                    <p className="font-hand text-2xl text-brick -rotate-1 sm:text-3xl">
                        carrier pigeons: please don't. the neighbor's cat has opinions.
                    </p>
                </FadeUp>
            </section>
            <Marquee />
            <NewsletterSection idPrefix="contact-newsletter" />
        </>
    );
};

export default Contact;
